var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLine7 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1,
  height: 35,
  viewBox: "0 0 1 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  y1: 2.18558e-8,
  x2: 0.499998,
  y2: 35,
  stroke: "black"
})));
export { SvgLine7 as ReactComponent };
export default __webpack_public_path__ + "e69e33e21b536323fa25966e25f2f2d5.svg";